export default "/images/vendor/flag-icon-css/flags/4x3/kn.svg?924ba78fe913a3dbd988f177c7aa962d";